import React, { memo, useState, useContext } from "react";
import PanelSingleTool from "./PanelSingleTool";
import { LoadMapContext } from "../../pages/sections/web-map/LoadWebMap";

const MapDecoupleBtn = () => {
  const { setIsMapsCoupled, isMapsCoupled } = useContext(LoadMapContext);
  const [isCoupled, setIsCoupled] = useState(isMapsCoupled);
  return (
    <>
      <PanelSingleTool
        toolTitle={isCoupled ? "Decouple" : "Couple"}
        handleClick={() => {
          setIsCoupled(!isCoupled);
          setIsMapsCoupled(!isCoupled);
        }}
        toolSelected={isCoupled}
        toolImg={"/assets/measuredistance.png"}
      />
    </>
  )
};

export default memo(MapDecoupleBtn);